import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LanguageHelper from "../../../../../helpers/LanguageHelper";
import { Modal } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Request from "../../../../../helpers/Request";
import ModalForm from "../../base/ModalForm";
import { modalStyles } from "../../../../../assets/styles/tableContainer";
import showSnackbar from "../../../../../components/Utils/showSnackbar";

const useStyles = makeStyles((theme) => modalStyles(theme));

export default function ApplicationUpdateModal({
  modal,
  setModal,
  setSnackbar,
  setSnackbarMessage,
  setSeverity,
  tableRef,
  options,
}) {
  const classes = useStyles();
  const language = LanguageHelper.getLanguage();
  const [loading, setLoading] = React.useState(false);

  const [applicationUpdateProps, setApplicationUpdateProps] = React.useState({
    type: null,
    username: null,
    password: null,
    description: null,
    dbBackup: false,
  });

  const createApplicationUpdate = async () => {
    setLoading(true);
    const response = await Request(
      "post",
      "/api/management/app-updates/isghub/publish",
      applicationUpdateProps,
    );
    showSnackbar(
      response,
      setSeverity,
      setSnackbarMessage,
      setSnackbar,
      language.etc.added,
      tableRef,
    );
    // Close modal after successful creation
    setLoading(false);
    handleCloseModal();
  };

  const handleCloseModal = () => {
    setApplicationUpdateProps({
      type: null,
      username: null,
      password: null,
      description: null,
      dbBackup: false,
    });
    setModal(false);
  };

  return (
    <>
      <Modal
        className={classes.modal}
        open={modal}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modal}>
          <div className={classes.paper}>
            <ModalForm
              applicationUpdateProps={applicationUpdateProps}
              setApplicationUpdateProps={setApplicationUpdateProps}
              createApplicationUpdate={createApplicationUpdate}
              loading={loading}
              options={options}
            />
          </div>
        </Fade>
      </Modal>
    </>
  );
}
